export const formFields = [
    {
        name: 'name',
        label: 'name',
        type: 'text',
        filter: true
    },
    {
        name: 'lastName',
        label: 'last name',
        type: 'text',
        filter: true
    },
    {
        name: 'email',
        label: 'e-mail',
        type: 'email',
        filter: true
    },
    {
        name: 'date',
        label: 'date',
        type: 'date',
        filter: false
    },
    {
        name: 'time',
        label: 'time',
        type: 'time',
        filter: false
    }
]